module.exports = __webpack_public_path__ + "static/media/TrameLettreinvestisseur.28db5084.docx";